/**
 * Every string anywhere inside a value, however deeply it's nested.
 *
 * A task's `data` is whatever the editor put there, so a reference can sit at
 * the top level, inside an object, or inside an array of them. Flattening it
 * first means the caller only has to think about strings.
 */
export const stringValuesIn = (value: unknown): string[] => {
  if (typeof value === 'string') return [value]
  if (Array.isArray(value)) return value.flatMap(stringValuesIn)
  if (value && typeof value === 'object') {
    return Object.values(value).flatMap(stringValuesIn)
  }
  return []
}
